import React, { useMemo } from 'react';
import { ToothPathologyDecay } from '../../../../../graphql/graphql';
import { SURFACES_TRANSLATION_MAP } from '../../../Helpers/surfaces/surfacesTranslationMap.helper';
import useTranslation from '../../../../../Hooks/useTranslation';
import { PATHOLOGY_TRANSLATION_MAP } from '../../../Helpers/pathology/pathologyTranslationMap.helper';
import styles from './DENTModalOverviewPathologyDecayListItem.module.scss';
import DENTMultipleSelectListItemActions from '../../DENTMultipleSelectList/DENTMultipleSelectListItemActions';

interface Props {
	decay: ToothPathologyDecay;
	handleEdit: () => void;
	handleDelete: () => void;
}

const DENTModalOverviewPathologyDecayListItem = ({
	decay,
	handleEdit,
	handleDelete,
}: Props) => {
	const { t } = useTranslation();

	const translatedSurfaces = useMemo(() => {
		return decay.surfaces.map(surface => t(SURFACES_TRANSLATION_MAP[surface]));
	}, [decay.surfaces]);

	if (!(decay?.surfaces?.length && decay?.values?.type)) {
		return <></>;
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.item}>
				<span>{t(PATHOLOGY_TRANSLATION_MAP[decay?.values?.type])}</span>
				<span>{translatedSurfaces.join(', ')}</span>
			</div>
			<DENTMultipleSelectListItemActions
				handleEdit={handleEdit}
				handleDelete={handleDelete}
			/>
		</div>
	);
};

export default DENTModalOverviewPathologyDecayListItem;
